import React from 'react';
import { css } from '@emotion/react';

export const InfoWrapper = ({
    children,
    isJobsCategory,
    isL2CarsForSale,
    ...props
}: React.PropsWithChildren<{
    isJobsCategory?: boolean;
    isL2CarsForSale?: boolean;
}>) => {
    const InfoWrapperStyles = css`
        display: flex;
        justify-content: space-between;
        align-items: ${isJobsCategory || isL2CarsForSale ? 'flex-end' : 'center'};
    `;

    return (
        <div css={InfoWrapperStyles} {...props}>
            {children}
        </div>
    );
};
